import { render } from "./List.vue?vue&type=template&id=0b89665c&scoped=true&bindings={\"list\":\"setup\",\"state\":\"setup\",\"currentParams\":\"setup\",\"movePage\":\"setup\",\"changeSortOptions\":\"setup\",\"adBanners\":\"setup\",\"internalLinks\":\"setup\"}"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=0b89665c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0b89665c"

export default script